import { Navigate } from 'react-router';
import type { ReactNode } from 'react';
import { ROUTES } from '@/constants';
import { isPasswordChangeRequired } from '@/services/auth';

/**
 * Wraps the app layout. While a password someone else set is unchanged, every route but
 * the change-password ones answers 403 (backend #274), so the layout would only fill with
 * refusals: send the user to the change page before it mounts.
 */
export const PasswordChangeGuard = ({ children }: { children: ReactNode }): React.JSX.Element =>
  isPasswordChangeRequired() ? <Navigate to={ROUTES.CHANGE_PASSWORD} replace /> : <>{children}</>;
